<template>
  <el-tag v-if="matched" :type="matched.listClass || ''" size="small">{{ matched.dictLabel }}</el-tag>
  <span v-else>{{ value !== null && value !== undefined ? value : '-' }}</span>
</template>

<script>
/**
 * DictTag — 字典值翻译组件
 *
 * 根据 dictValue 自动查找对应的 dictLabel 和 listClass，渲染为 el-tag。
 * 若未能匹配则显示原始 value 值。
 *
 * Props:
 *   dictType  (String, 必填) 字典类型标识，如 'tool_type'
 *   value     (String/Number, 必填) 需要翻译的键值
 *
 * 用法示例：
 *   <DictTag dict-type="tool_type" :value="row.toolType" />
 */
import { getDictDataByType } from './dict.api';

export default {
  name: 'DictTag',

  props: {
    dictType: { type: String, required: true },
    value: { type: [String, Number], default: null }
  },

  data() {
    return {
      options: []
    };
  },

  computed: {
    matched() {
      if (this.value === null || this.value === undefined || !this.options.length) return null;
      return this.options.find((item) => String(item.dictValue) === String(this.value)) || null;
    }
  },

  watch: {
    dictType: {
      immediate: true,
      handler(val) {
        if (val) this.loadOptions(val);
      }
    }
  },

  methods: {
    async loadOptions(dictType) {
      try {
        this.options = await getDictDataByType(dictType);
      } catch (e) {
        this.options = [];
        console.warn('[DictTag] 字典数据加载失败:', dictType, e);
      }
    }
  }
};
</script>
